import styled from 'styled-components';

export const OuterContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 8px 0 0;
  overflow: hidden;
  width: auto;
  max-width: 100%;
  height: 100%;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow-x: auto;
  scrollbar-width: none;
  position: relative;
  height: 100%;
  scroll-snap-type: x mandatory;
  padding: 0;
  max-width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const Boundary = styled.div`
  width: 1px;
  height: 100%;
  flex-shrink: 0;
  pointer-events: none;

  &.start-boundary {
    margin-left: -1px;
  }

  &.end-boundary {
    margin-right: -1px;
  }
`;
